/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import styles from '../../setup.steps.styl'
import type { StepProps } from '../../models'
import { SubmitButton } from '@src/components/common/button'

export const UserInformationFooter: React.FC<StepProps> = (
  props: StepProps
) => (
  <div className={styles.buttonWrapper} role="button-wrapper">
    <SubmitButton
      role="next-button"
      className={styles.nextButton}
      title={'NEXT'}
    />
  </div>
)
